class StoresList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  static get requiredElements () {
    return ['details']
  }

  static get requiredExternalElements () {
    return ['trigger', 'store-image-text']
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)

    this.externalEls.trigger.elements.forEach(el => {
      this.listeners.add(el, 'click', this.onClick)
    })
  }

  onClick (e) {
    this.hideAll()

    const indexToReveal = e.target.getAttribute('data-index')

    if (indexToReveal) {
      this.externalEls['store-image-text'].elements[
        indexToReveal
      ].classList.add('st-Store_ImageDetails-visible')
      this.externalEls['store-mobile-image'].elements[
        indexToReveal
      ].classList.add('st-Store_MobileImage-visible')

      this.els.details.elements[indexToReveal].classList.add(
        'st-Store_Details-visible',
      )

      e.target.classList.add('st-Store_LinkActive')
    }
  }

  // Hide all store images and details.
  hideAll () {
    this.externalEls['store-image-text'].elements.forEach(el => {
      el.classList.remove('st-Store_ImageDetails-visible')
    })

    this.externalEls['store-mobile-image'].elements.forEach(el => {
      el.classList.remove('st-Store_MobileImage-visible')
    })

    this.externalEls.trigger.elements.forEach(el => {
      el.classList.remove('st-Store_LinkActive')
    })

    this.els.details.elements.forEach(el => {
      el.classList.remove('st-Store_Details-visible')
    })
  }
}

if (!customElements.get('stores-list')) {
  customElements.define('stores-list', StoresList)
}
